import { render, staticRenderFns } from "./Step6.vue?vue&type=template&id=172ff239&scoped=true"
import script from "./Step6.vue?vue&type=script&lang=js"
export * from "./Step6.vue?vue&type=script&lang=js"
import style0 from "./Step6.vue?vue&type=style&index=0&id=172ff239&prod&scoped=true&lang=css"
import style1 from "./Step6.vue?vue&type=style&index=1&id=172ff239&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "172ff239",
  null
  
)

export default component.exports